import { RadioGroupOption } from '@/components/form/baseInputs/inputTypes';
import { InsurancePolicyDetailsSubformType } from '@/modules/entities/InsurancePolicyDetailsSubform/InsurancePolicyDetailsSubform.types';
import { StructuredAssetsSubformProperties } from '@/modules/entities/StructuredAssetsSubform/StructuredAssetsSubform.types';

export type HoldingType = 'asset' | 'liability' | 'insurance';

// Base form properties shared across all holding types
type BaseHoldingFormShape = {
  holdingsGroupId: string | null;
  valuationAsOfDate: Date | null;
};

// Asset-specific form shape
export type AssetHoldingsFormShape = BaseHoldingFormShape & {
  holdingType: 'asset';
  structuredAssetsSubform: StructuredAssetsSubformProperties;
};

// Liability-specific form shape
export type LiabilityHoldingFormShape = BaseHoldingFormShape & {
  holdingType: 'liability';
  liabilityAmount: number | null;
  liabilityDescription: string;
  interestRate: number | null;
};

// Insurance-specific form shape
export type InsuranceHoldingFormShape = BaseHoldingFormShape & {
  holdingType: 'insurance';
  insurancePolicyDetailsSubform: InsurancePolicyDetailsSubformType;
};

// Discriminated union of all holding form types
export const HOLDING_TYPE_OPTIONS: RadioGroupOption<HoldingType>[] = [
  { value: 'asset', label: 'Asset' },
  { value: 'liability', label: 'Liability or receivable' },
  { value: 'insurance', label: 'Insurance' },
];
